// To be used to render a snake_cased variable as readable text
export const toHuman = value => {
  if (!value) return ''
  const parts = value.split('_')
  return parts.map(part => part.substr(0, 1).toUpperCase() + part.substr(1)).join(' ')
}

// To be used to read the contents of a specified file
export const getBase64 = file => {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    if (!(file instanceof Blob)) reject(new Error('File is not instance of Blob'))
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
  })
}

// To be used to remove the possible file extenstion from a string
export const removeFileExtension = fileName => {
  if (typeof fileName !== 'string' || !fileName.includes('.')) return fileName
  const fileNameParts = fileName.split('.')
  if (fileNameParts.pop().length > 4) return fileName
  return fileNameParts.join('.')
}

// To be used to render an asset/complex address (including the city)
export const adresPlaatsRenderer = params => {
  if (!params.value || typeof params.value !== 'object') return ''

  let adres = adresRenderer(params)
  if (params.value.plaats) adres += `, ${params.value.plaats}`

  return adres
}

// To be used to render a vessel name and build year
export const vesselNameYearRenderer = ({ value }) => {
  if (!value || typeof value !== 'object') return ''
  return `${value.name || ''} (${value.build || 'n.a.'})`
}

// To be used to render an asset/complex address (without the city)
export const adresRenderer = ({ value }) => {
  if (!value || typeof value !== 'object') return ''
  return `${value.straatnaam || ''} ${value.huisnummer || ''}${value.toevoeging || ''}`
}

// To be used to return a date object of the value of a table field
export const dateGetter = params => {
  // Grouped rows dont have data
  if (params && params.data) {
    const value = params.data[params.colDef.field]

    if (!value) return ''

    const [year, month, date] = value.split(' ')[0].split('-')
    return new Date(+year, +month - 1, +date)
  }
}

// To be used to return a function which gives a human readable date
export const dateRenderer = () => {
  return params => params.value ? params.value.toDateString() : ''
}

// To be used to get a date object from a string
export const parseDateString = dateString => {
  const [date, time] = dateString.split(' ')
  if (!date) return

  const [day, month, year] = date.split('-')
  if (time) {
    const [hours, minutes] = time.split(':')
    return new Date(+year, +month - 1, +day, +hours, +minutes)
  }
  else {
    return new Date(+year, +month - 1, +day)
  }
}

// To be used to return a more human readable datetime string
export const getDateTimeStringFromServer = serverDate => {
  if (typeof serverDate !== 'string') return ''
  const [date, time] = serverDate.split(' ')
  const [year, month, day] = date.split('-')
  const [hours, minutes] = time.split(':')
  return `${day}-${month}-${year} ${hours}:${minutes}`
}

// To be used to return a more human readable time string
export const getTimeStringFromServer = serverDate => {
  if (typeof serverDate !== 'string') return ''
  const [hours, minutes] = serverDate.split(' ')[1].split(':')
  return `${hours}:${minutes}`
}

// To be used to check if the date of two datetime strings are different
export const isDateDifferent = (date1, date2) => {
  if (typeof date1 !== 'string' || typeof date2 !== 'string') return undefined
  return date1.split(' ')[0] !== date2.split(' ')[0]
}

// To be used when moving a row in a table
export const moveInArray = (arr, fromIndex, toIndex) => {
  const element = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, element)
}

// To be used to get an object with all the query params
export const parseQueryString = str => {
  return (str || '').split('&').reduce((obj, keyValue) => {
    if (keyValue) {
      const [key, value] = keyValue.split('=')
      obj[decodeURIComponent(key)] = value ? decodeURIComponent(value) : true
    }
    return obj
  }, {})
}
